import { isNotDefined } from '@sgme/fp';
import { FormattedDate } from 'react-intl';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField';
import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const HedgePaymentDate = () => {
  const tileId = useForwardAccumulatorTileId();
  const hedgePaymentDate = useAppSelector((state) =>
    selectForwardAccumulatorProperty(state, tileId, 'hedgePaymentDate'),
  );

  if (isNotDefined(hedgePaymentDate)) {
    return null;
  }

  return (
    <FormField formattedMessageId="targetAccumulator.form.hedgePaymentDate">
      <span className="fs-12 ps-2">
        <FormattedDate value={hedgePaymentDate} day="2-digit" month="short" year="numeric" timeZone="UTC" />
      </span>
    </FormField>
  );
};
